export enum SyncDirection {
  BOTH = 'both',
  DOWN = 'down',
  UP = 'up',
}

export const DEFAULT_FIELD_DATA: Record<string, Record<string, SyncDirection>> = {
  contact: {
    email: SyncDirection.BOTH,
    phone: SyncDirection.BOTH,
    firstName: SyncDirection.BOTH,
    lastName: SyncDirection.BOTH,
    title: SyncDirection.BOTH,
    stage: SyncDirection.BOTH,
    owner: SyncDirection.BOTH,
    timezone: SyncDirection.BOTH,
  },
  company: {
    name: SyncDirection.BOTH,
    description: SyncDirection.BOTH,
    domain: SyncDirection.BOTH,
    revenue: SyncDirection.BOTH,
    industry: SyncDirection.BOTH,
    targetAccount: SyncDirection.BOTH,
    idealCustomerProfileTier: SyncDirection.BOTH,
    sizeEstimateLow: SyncDirection.BOTH,
    location: SyncDirection.BOTH,
    country: SyncDirection.BOTH,
    owner: SyncDirection.BOTH,
  },
  deal: {
    amount: SyncDirection.BOTH,
    closeDate: SyncDirection.BOTH,
    name: SyncDirection.BOTH,
    stage: SyncDirection.BOTH,
    type: SyncDirection.BOTH,
    owner: SyncDirection.BOTH,
    priority: SyncDirection.BOTH,
  },
};

export const DEFAULT_FIELD_META: Record<'contact' | 'company' | 'deal', any> = {
  contact: {
    email: { label: 'Email', type: 'string' },
    phone: { label: 'Phone', type: 'string' },
    firstName: { label: 'First Name', type: 'string' },
    lastName: { label: 'Last Name', type: 'string' },
    title: { label: 'Title', type: 'string' },
    stage: { label: 'Stage', type: 'string' },
    owner: { label: 'Owner', type: 'string' },
    timezone: { label: 'Time Zone', type: 'string' },
  },
  company: {
    name: { label: 'Company Name', type: 'string' },
    description: { label: 'Description', type: 'string' },
    domain: { label: 'Domain', type: 'string' },
    revenue: { label: 'Revenue', type: 'integer' },
    industry: { label: 'Industry', type: 'string' },
    targetAccount: { label: 'Target Account', type: 'bool' },
    idealCustomerProfileTier: { label: 'ICP Tier', type: 'string' },
    sizeEstimateLow: { label: 'Number of Employees', type: 'integer' },
    location: { label: 'Location', type: 'string' },
    owner: { label: 'Owner', type: 'string' },
    country: { label: 'Country', type: 'string' },
  },
  deal: {
    amount: { label: 'Amount', type: 'integer' },
    closeDate: { label: 'Close Date', type: 'string' },
    name: { label: 'Name', type: 'string' },
    stage: { label: 'Stage', type: 'string' },
    type: { label: 'Type', type: 'string' },
    owner: { label: 'Owner', type: 'string' },
    priority: { label: 'Priority', type: 'string' },
  },
};
